import { render, staticRenderFns } from "./QuotationButtonApprove.vue?vue&type=template&id=0dbdbf54&lang=html"
import script from "./QuotationButtonApprove.vue?vue&type=script&lang=js"
export * from "./QuotationButtonApprove.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports